import pxToRem from "hooks/usePxToRem";

import {Box, Grid} from "@mui/system";

import {CustomAutoComplete} from "ui";
import {useState} from "react";
import {AutoCompleteData} from "ui/CustomAutoComplete/CustomAutoComplete";
import {Controller, useFormContext} from "react-hook-form";
import useChangeDAteAndAutocomplete from "views/ProcessDetails/hooks/useChangeDAteAndAutocomplete";
import useHandlePaginatedOptions from "views/ProcessDetails/hooks/useHandlePaginatedOptions";
import {getTooltipText} from "views/ProcessDetails/utils/getTooltipText";
import {CorrespondenceModal} from "components/HelperIconAndModal";
import {ProcessDatePicker} from "components";
import {ProcessTextField} from "views/ProcessDetails/refactor/components";
import {Icon, IconButton} from "@mui/material";
import {Process} from "views/ProcessDetails/refactor/types/process.types";
import {
  getCorrespondenceModalContent,
  getCorrespondenceModalItems,
} from "views/ProcessDetails/refactor/utils/correspondence";

const BasicInfo = () => {
  const {control} = useFormContext<Process>();

  const [clientOptions, setClientOptions] = useState<AutoCompleteData[]>(
    [] as AutoCompleteData[],
  );

  const {handleChangeAutocomplete} = useChangeDAteAndAutocomplete();

  const {getOptions, onBottomScroll, isLoadingOptions, pageState} =
    useHandlePaginatedOptions();

  const [searchFields, setSearchFields] = useState({
    client: "",
    vessels: "",
  });

  const [correspondenceModalIsOpen, setCorrespondenceModalIsOpen] =
    useState(false);
  const [correspondenceModalContent, setCorrespondenceModalContent] =
    useState("");
  const [correspondenceModalItems, setCorrespondenceModalItems] = useState<
    string[]
  >([]);
  const [correspondenceModalTitle, setCorrespondenceModalTitle] = useState("");

  const handleOpenHelperModal = (
    content: string,
    title: string,
    items?: string[],
  ) => {
    setCorrespondenceModalTitle(title);
    setCorrespondenceModalContent(content);
    setCorrespondenceModalItems(items ?? [content]);
    setCorrespondenceModalIsOpen(true);
  };

  const handleCloseModal = () => {
    setCorrespondenceModalIsOpen(false);
    setCorrespondenceModalContent("");
    setCorrespondenceModalItems([]);
  };
  return (
    <>
      <CorrespondenceModal
        isOpen={correspondenceModalIsOpen}
        correspondenceText={correspondenceModalContent}
        correspondenceItems={correspondenceModalItems}
        correspondenceTitle={correspondenceModalTitle}
        onClose={handleCloseModal}
      />
      <Grid container spacing={pxToRem(8)} mb={pxToRem(20)}>
        {/* Ocultei  o campo número do processo pois isso já é exibido em outro local na tela e 
        precisávamos adicionar mais um campo (Ref. Interna) nessa linha. 
        */}
        {/* <Controller
          name="processNumber"
          control={control}
          render={({field: {value}}) => (
            <Grid size={2}>
              <ProcessTextField
                value={value}
                name="processNumber"
                label="Número de processo"
                disabled
              />
            </Grid>
          )}
        /> */}
        <Grid size={2}>
          <Controller
            name="dateProcessOpening"
            control={control}
            render={({field: {value}}) => (
              <ProcessDatePicker
                value={value}
                name="dateProcessOpening"
                disabled
                label="Data abertura"
                fullWidth
              />
            )}
          />
        </Grid>
        <Controller
          name="client"
          control={control}
          render={({field: {value}}) => (
            <Grid size={3} display="flex" alignItems="start">
              <Box
                sx={{
                  borderLeft: `0.5px solid lightgrey`,
                }}
              >
                <IconButton
                  size="small"
                  onClick={() =>
                    handleOpenHelperModal(
                      getCorrespondenceModalContent(value),
                      "Cliente",
                      getCorrespondenceModalItems(value),
                    )
                  }
                >
                  <Icon>markunread_box</Icon>
                </IconButton>
              </Box>
              <CustomAutoComplete
                size="small"
                name="client"
                placeholder="Cliente"
                label="Cliente"
                tooltipText={getTooltipText(value?.name)}
                isLoading={isLoadingOptions}
                value={value?.name ?? ""}
                onChangeFn={(e, value) =>
                  handleChangeAutocomplete(e, value, "client")
                }
                optionSecondaryContent
                options={clientOptions}
                onOpen={
                  clientOptions.length > 0
                    ? undefined
                    : () => getOptions({isClient: true}, setClientOptions)
                }
                onBottomScroll={() =>
                  onBottomScroll(
                    {isClient: true, clientName: searchFields.client},
                    setClientOptions,
                  )
                }
                hasMorePagesToLoad={pageState.currentPage < pageState.lastPage}
                onInputChange={(e, value) => {
                  //condição pra não fazer a requisição na primeira atualização do input
                  if (e !== null) {
                    setSearchFields((prev) => ({...prev, client: value}));
                    getOptions(
                      {isClient: true, clientName: value},
                      setClientOptions,
                    );
                  }
                }}
              />
            </Grid>
          )}
        />

        <Grid size={2}>
          <Controller
            name="internalReference"
            control={control}
            rules={{
              maxLength: {
                value: 25,
                message: "Max. 25 caracteres",
              },
            }}
            render={({field: {onChange, value}, fieldState: {error}}) => (
              <ProcessTextField
                value={value}
                onChange={onChange}
                name="internalReference"
                label="Ref. Interna"
                fullWidth
                error={!!error}
                helperText={error?.message}
              />
            )}
          />
        </Grid>

        <Controller
          name="clientReference"
          control={control}
          render={({field: {onChange, value}}) => (
            <Grid size={3}>
              <ProcessTextField
                value={value}
                name="clientReference"
                label="Referência Cliente"
                onChange={onChange}
              />
            </Grid>
          )}
        />
        <Grid size={2}>
          <Controller
            name="externalReference"
            control={control}
            render={({field: {onChange, value}}) => (
              <ProcessTextField
                value={value}
                name="externalReference"
                onChange={onChange}
                label="Ref. Externa"
                fullWidth
              />
            )}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default BasicInfo;
